app.directive('interestInput', ['$filter', function($filter){
    return {
        restrict: 'EAC',
        scope: {
            ngModel: '=?',
            xyValue: '='
        },
        link: function($scope, element) {

            var focused = false;

            $scope.ngModel = $filter('number')($scope.xyValue);

            $scope.$watch('ngModel', function() {
                if (focused) {
                    var value = $scope.ngModel || '';
                    $scope.ngModel = (value + '').replace('%','').replace(',', '.');
                    $scope.xyValue = parseFloat(value) || 0;
                }
            });

            $scope.$watch('xyValue', function() {
                if (focused) {
                    $scope.ngModel = $scope.xyValue;
                } else {
                    $scope.ngModel = $filter('number')($scope.xyValue)+'%';
                }
            });

            element.on('focus', function() {
                $scope.$apply(function() {
                    focused = true;
                    $scope.ngModel = $scope.xyValue;
                });

            });

            element.on('blur', function() {
                $scope.$apply(function() {

                    focused = false;

                    $scope.xyValue = $scope.ngModel;

                    $scope.ngModel = $filter('number')($scope.xyValue)+'%';

                });
            });
        }
    };
}]);